/**
 * Product gallery lightbox — single product page. Every image (main image
 * included, see index.php) shares one GLightbox instance/gallery key, so
 * clicking any of them opens the same swipeable carousel.
 */

import './index.scss';
import 'glightbox/dist/css/glightbox.min.css';
import GLightbox from 'glightbox';

if (document.querySelector('[data-product-gallery]')) {
	GLightbox({
		selector: '.product-gallery__item',
		touchNavigation: true,
		loop: true,
	});
}
